import styled from "styled-components";
export const Styles = styled.div`
  .lesson {
    box-shadow: -2px 5px 10px #46454774 !important;
    width: 90%;

    ${(props) =>
      props.isAr
        ? `transform: translateX(-5%);`
        : `transform: translateX(5%);`};
    border-start-end-radius: 25px;
    border-end-start-radius: 25px;
    cursor: pointer;
  }
  .lesson .lesson-img {
    position: relative;
    width: 100%;
    height: 150px;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lesson .lesson-img img {
    width: 125px;
    height: 125px;
    object-fit: cover;
    transition: 0.3s;
  }
  .lesson .lesson-img.selected img {
    width: 125px;
    height: 125px;
    object-fit: cover;
    transition: 0.3s;
    transform: scale(1.1);
  }
  .lesson:hover .lesson-img img {
    transform: scale(1.1);
  }
  .lesson .lesson-img .watched {
    position: absolute;
    top: 0;
    left: 0;
    background: var(--dark-purple);
    padding: 5px;
    font-size: 13px;
    border-radius: 10px;
    color: #fff;
  }
  .lesson .lesson-img .watched.selected {
    background: var(--dark-color);
  }
  .lesson .lesson-info {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .lesson .lesson-info .lesson-title {
    color: var(--blue);
  }
  .lesson .lesson-info .lesson-number {
    color: var(--cryn);
  }
  @media (max-width: 1400px) {
    .lesson .lesson-img {
      height: 125px;
    }
    .lesson .lesson-img img {
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 1200px) {
    .lesson .lesson-img {
      height: 100px;
    }
    .lesson .lesson-img img {
      width: 80px;
      height: 80px;
    }
  }
  @media (max-width: 992px) {
    .lesson .lesson-img {
      height: 125px;
    }
    .lesson .lesson-img img {
      width: 100px;
      height: 100px;
    }
  }
  @media (max-width: 500px) {
    .lesson .lesson-img {
      height: 75px;
    }
    .lesson .lesson-img img {
      width: 60px;
      height: 60px;
    }
  }
`;
